import type {
  ICreatePremiumInvoicePayload,
  IPremiumInvoice,
  IPremiumInvoiceFilters,
  IUpdateInvoiceForm,
} from '@/types/asicw/invoices'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getPremiumInvoices(filters: IPremiumInvoiceFilters): Promise<IPage<IPremiumInvoice>> {
  const res = await axios.get(import.meta.env.VITE_APP_ASICW_PREMIUM_INVOICES_ENDPOINT, { params: filters })
  return res.data
}

export async function createPremiumInvoice(data: ICreatePremiumInvoicePayload) {
  const formData = new FormData()
  formData.append('policy_group_id', data.policy_group_id!.toString())
  formData.append('policies_quantity', data.policies_quantity!.toString())
  formData.append('policy_group_premium', data.policy_group_premium!.toString())
  formData.append('policy_underwriting_fee', data.policy_underwriting_fee!.toString())
  formData.append('type', data.type)
  formData.append('issue_date', data.issue_date)
  formData.append('due_date', data.due_date)
  formData.append('status', data.status)
  if (data.invoice_file) {
    formData.append('invoice_file', data.invoice_file)
  }
  if (data.commission_percentage) {
    formData.append('commission_percentage', data.commission_percentage.toString())
  }

  const res = await axios.post(`${import.meta.env.VITE_APP_ASICW_PREMIUM_INVOICES_ENDPOINT}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return res.data
}

export async function deletePremiumInvoice(invoiceId: number) {
  const res = await axios.delete(`${import.meta.env.VITE_APP_ASICW_PREMIUM_INVOICES_ENDPOINT}/${invoiceId}`)
  return res.data
}

export async function updatePremiumInvoice(invoiceId: number, data: IUpdateInvoiceForm) {
  const res = await axios.patch(`${import.meta.env.VITE_APP_ASICW_PREMIUM_INVOICES_ENDPOINT}/${invoiceId}`, data)
  return res.data
}
